import store from '@/store'

export default (to, from, next) => {
    if (!store.getters.check) {
        next({ name: 'login' })
    } else {
        next()
    }
}


// WEBPACK FOOTER //
// ./src/middleware/auth.js